import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_inventory_transfers_hub_ComponentContextService } from './FootprintManager.inventory_transfers_hub.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { FootprintManager_inventory_transfers_gridComponent } from './FootprintManager.inventory_transfers_grid.component';
import { Locations_warehouses_dd_multiComponent } from './Locations.warehouses_dd_multi.component'
import { Owners_projects_dd_singleComponent } from './Owners.projects_dd_single.component'
import { InventoryTransfers_inventory_transfer_statuses_dd_multiComponent } from './InventoryTransfers.inventory_transfer_statuses_dd_multi.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootprintManager_inventory_transfers_gridComponent),
    forwardRef(() => Locations_warehouses_dd_multiComponent),
    forwardRef(() => Owners_projects_dd_singleComponent),
    forwardRef(() => InventoryTransfers_inventory_transfer_statuses_dd_multiComponent),
  ],
  selector: 'FootprintManager-inventory_transfers_hub',
  templateUrl: './FootprintManager.inventory_transfers_hub.component.html'
})
export class FootprintManager_inventory_transfers_hubComponent extends BaseComponent implements OnInit, OnDestroy {


  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  formGroup: FormGroup = new FormGroup({
    warehouses: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    source_project: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    target_project: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    statuses: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  toolbar = {
      create_transfer: new ToolModel(new ButtonModel('create_transfer', new ButtonStyles(['creation'], null), false, false, false, 'New transfer', 'icon-ic_fluent_add_20_regular', null)
    , false)
  };

  actionbar = {
  };

 filters = {
    warehouses: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['warehouses'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Warehouses', false, false),
    source_project: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['source_project'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Source project', false, false),
    target_project: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['target_project'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Target project', false, false),
    statuses: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['statuses'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Statuses', false, false),
  };


  filtersets = {
    filters: new FieldsetModel(
      'Filters',
      false,
      true,
      false,
      false,
        null
      ,
      () => {
        const $hub = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      inventory_transfers: new TabItemModel(
        this.rootTabGroup, 
        'Inventory transfers', 
        false,
        ),
    };
  
  
    //#region tabs inParams
    cacheValueFor_$tabs_inventory_transfers_inventory_transfers_grid_inParams_warehouses: number[];
    get $tabs_inventory_transfers_inventory_transfers_grid_inParams_warehouses(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.warehouses.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_inventory_transfers_inventory_transfers_grid_inParams_warehouses, expr)) {
        this.cacheValueFor_$tabs_inventory_transfers_inventory_transfers_grid_inParams_warehouses = expr;
      }
      return this.cacheValueFor_$tabs_inventory_transfers_inventory_transfers_grid_inParams_warehouses;
    }
  
    get $tabs_inventory_transfers_inventory_transfers_grid_inParams_sourceProjectId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.source_project.control.value;
      
      return expr;
    }
  
    get $tabs_inventory_transfers_inventory_transfers_grid_inParams_targetProjectId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.target_project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_inventory_transfers_inventory_transfers_grid_inParams_statusIds: number[];
    get $tabs_inventory_transfers_inventory_transfers_grid_inParams_statusIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.statuses.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_inventory_transfers_inventory_transfers_grid_inParams_statusIds, expr)) {
        this.cacheValueFor_$tabs_inventory_transfers_inventory_transfers_grid_inParams_statusIds = expr;
      }
      return this.cacheValueFor_$tabs_inventory_transfers_inventory_transfers_grid_inParams_statusIds;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_inventory_transfers', { read: FootprintManager_inventory_transfers_gridComponent }) $tabs_inventory_transfers: FootprintManager_inventory_transfers_gridComponent;
    //#endregion tabs children

  //#region filters inParams
  get $fields_source_project_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_target_project_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  //#endregion filters inParams

  get hubTitle(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Inventory transfers hub`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Move stock between owners and projects with full traceability.`;
  }

  constructor(
  private $utils: UtilsService,
  private $settings: SettingsValuesService,
  private $shell: FootprintManager_ShellService,
  private $datasources: FootprintManager_DatasourceService,
  private $flows: FootprintManager_FlowService,
  private $reports: FootprintManager_ReportService,
  private $localization: FootprintManager_LocalizationService,
  private $operations: FootprintManager_OperationService,
  private $logger: CleanupLoggerService,
  private $context: FootprintManager_inventory_transfers_hub_ComponentContextService,
  ) { 
    super();
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.inventory_transfers,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Inventory transfers hub';
    
    const $hub = this;
    const $utils = this.$utils;

    (this.filters.statuses.control as SelectBoxModel).reset([1,2,3,4,7]);

    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region tabs children
    if (childToSkip !== '$tabs_inventory_transfers') {
      if (!isNil(this.$tabs_inventory_transfers) && !this.tabs.inventory_transfers.hidden) {
        this.$tabs_inventory_transfers.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_create_transfer_clicked(event = null) {
    return this.on_create_transfer_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_create_transfer_clickedInternal(
    $hub: FootprintManager_inventory_transfers_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_transfers_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $shell.FootprintManager.openinventory_transfer_creation_form();
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: FootprintManager_inventory_transfers_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_transfers_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if (await $operations.FootprintManager.Disable_Navigation_Inventory_Inventory_Transfers.isAuthorized()) {
      
      $hub.close();
      throw new Error ('This screen currently requires authorization, please see your system admin for access.')
    
  }
  
  
  
  if ((await $operations.FootprintManager.Enable_Locations_DefaultWarehouseByActivity.isAuthorized())) {
      let username = (await $flows.Utilities.get_username_flow({})).userName;
      let defaultWarehouseResult = (await $datasources.Locations.ds_get_default_warehouse_by_user.get({ userName: username })).result;
  
      $hub.filters.warehouses.control.value = $utils.isDefined(defaultWarehouseResult?.warehouseId) ? [defaultWarehouseResult.warehouseId] : null;
  }
  
  
  if ((await $operations.FootprintManager.Disable_InventoryTransfers_TransferCreation.isAuthorized())){
      $hub.toolbar.create_transfer.hidden = true;
  }
  }
  //#endregion private flows
}
